<template>
    <div class="edit-structure page-layout__inner w-100">
        <div class="row w-100">
            <div class="col-md-7">
                <div class="section">
                    <EditCreateComponent :id="structureId" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EditCreateComponent from "./components/EditCreateComponent";

    export default {
        name: "Edit",
        components: {EditCreateComponent},
        computed: {
            structureId() {
                return this.$route.params.id;
            }
        }
    }
</script>

<style scoped>

</style>